import { render, staticRenderFns } from "./AnswersReport.vue?vue&type=template&id=2ead3aa8&"
import script from "./AnswersReport.vue?vue&type=script&lang=js&"
export * from "./AnswersReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports